import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { UpsertExternalConnectionPayload, UpsertExternalConnectionInput } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
const MUTATION_UPSERT_EXTERNAL_CONNECTION = gql`
    mutation upsertExternalConnection($input: UpsertExternalConnectionInput!){
        upsertExternalConnection(input: $input){
            message
            errors {
                code
                message
            }
            result
            externalConnection {
                externalConnectionType,
                description
            }
        }
    }
`;

export const mutationUpsertExternalConnection = async (
    client: ApolloClient<NormalizedCacheObject>,
    args: { upsertExternalConnectionData: UpsertExternalConnectionInput }
): Promise<UpsertExternalConnectionPayload | undefined> => {
    const { description, externalConnectionType, isForClient, isForPartner, isForAdd } = args.upsertExternalConnectionData;
    const { data, errors } = await client.mutate<{ upsertExternalConnection: UpsertExternalConnectionPayload }>({
        variables: { input: { 
                externalConnectionType,
                description,
                isForClient,
                isForPartner,
                isForAdd
            } 
        },
        mutation: MUTATION_UPSERT_EXTERNAL_CONNECTION
    });
    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console
            console.error(error);
        });
        // Friendly error to active user
        throw new Error('An error has occurred during the save of external connection.');
    }
    if (data && data.upsertExternalConnection) {
        return data.upsertExternalConnection;
    }

    return undefined;
};
